import { Component, Input } from '@angular/core';
import { Breadcrumbs } from 'src/app/shared/models/breadcrumbs';

@Component({
  selector: 'entitlement-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: [],
})
export class BreadcrumbsComponent {
  @Input() items: Breadcrumbs[];

  constructor() {}
}
